import { Button, ButtonText, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent, useState } from 'react'
import { Alert, StyleSheet, TextInput } from 'react-native'
import { i18n } from '../../lib/i18n'
import { theme } from '../../theme'

interface LoginProps {
  userName?: string
  password?: string
  error?: string | null
  onPress: (userName: string, pwd: string) => void
}

export const Login: FunctionComponent<LoginProps> = ({ userName, password, error, onPress }) => {
  const [loginValue, setLoginValue] = useState<string>(userName || '')
  const [pwdValue, setPwdValue] = useState<string>(password || '')

  const onPressSubmit: Function = () => {
    if (!loginValue || !loginValue) {
      Alert.alert('Utilisateur et mot de passe obligatoire')
      return
    }
    onPress(loginValue.trim(), pwdValue.trim())
  }

  const renderError: Function = () => {
    if (!error) {
      return
    }
    return <Text style={styles.errorText}>{error}</Text>
  }

  return (
    <View>
      <Text>{i18n.t('login.userName')}</Text>
      <TextInput style={styles.input} value={loginValue} onChangeText={text => setLoginValue(text)} textContentType="username" />

      <Text>{i18n.t('login.password')}</Text>
      <TextInput style={styles.input} secureTextEntry value={pwdValue} onChangeText={text => setPwdValue(text)} textContentType="password" />

      {renderError()}
      <Button style={{ marginTop: theme.padding.x2 }} onPress={() => onPressSubmit()}>
        <ButtonText style={styles.buttonText}>{i18n.t('grcYpok.login')}</ButtonText>
      </Button>
    </View>
  )
}

const styles = StyleSheet.create({
  buttonText: {
    width: '100%',
    textAlign: 'center',
    color: theme.colors.white,
  },
  errorText: {
    color: theme.colors.red,
    paddingVertical: theme.padding.x2,
  },
  input: {
    borderWidth: 1,
    borderColor: theme.colors.silver,
    borderRadius: 4,
    paddingHorizontal: 12,
    paddingVertical: 10,
    marginTop: 4,
    marginBottom: theme.padding.x2,
    fontSize: 16,
  },
})
